import { render } from "./Introduction.vue?vue&type=template&id=6bc75e73"
import script from "./Introduction.vue?vue&type=script&lang=js"
export * from "./Introduction.vue?vue&type=script&lang=js"
script.render = render

export default script